import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { generateCustomizedSyncBody } from 'utils/CustomizedSync'

import { saveQuickIntegrationError, saveQuickIntegrationSuccess } from './actions'
import { QUICK_INTEGRATION_SAVE_ASYNC } from './constants'

const saveQuickIntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(QUICK_INTEGRATION_SAVE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .saveQuickIntegration(state$.value.partnerOptions.selectedCompany?.value, {
          ...state$.value.settings.emailServer.quickIntegration.data,
          ...action.payload.data,
          ...generateCustomizedSyncBody(state$),
        })
        .pipe(
          map((response) => saveQuickIntegrationSuccess(response)),
          catchError((error) => of(epicsErrorHandler(saveQuickIntegrationError, error)))
        )
    )
  )

export default combineEpics(saveQuickIntegrationEpic)
